'use client';

import React from 'react';

import RichText from '@/components/ui/RichText/RichText';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { normalizeRichText } from '@/utils/normalizeRichText';

import type { RegistrationStepsProps } from './RegistrationSteps.types';

export default function RegistrationSteps({
  id,
  heading,
  subheading,
  bottomText,
  steps,

  sectionClassName = '',
  containerClassName = '',
  gridClassName = '',

  stepCardClassName = '',
  circleClassName = '',
}: RegistrationStepsProps): React.ReactElement {
  console.log(bottomText);
  const { ref, sectionClasses, childClasses, getChildStyle } =
    useScrollAnimation();

  const headingData = normalizeRichText(heading);
  const subheadingData = normalizeRichText(subheading);
  const bottomTextData = normalizeRichText(bottomText);

  return (
    <section
      id={id}
      ref={ref}
      className={`content-wrapper w-full pt-8 pb-4 md:pt-10 md:pb-6 ${sectionClassName} ${sectionClasses}`}
    >
      <div className={`mx-auto px-0 text-center ${containerClassName}`}>
        {headingData?.content && (
          <div className={childClasses()} style={getChildStyle(100)}>
            <RichText
              styles={
                headingData.styles || {
                  h2: 'text-theme-primary text-[24px] md:text-[32px] font-bold mb-2',
                }
              }
            >
              {headingData.content}
            </RichText>
          </div>
        )}

        {subheadingData?.content && (
          <div className={childClasses()} style={getChildStyle(200)}>
            <RichText
              styles={
                subheadingData.styles || {
                  p: 'text-text-muted text-sm md:text-base mb-10 md:mb-14',
                }
              }
            >
              {subheadingData.content}
            </RichText>
          </div>
        )}

        <div
          className={`grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-6 ${gridClassName}`}
        >
          {steps.map((step, index) => {
            const titleData = normalizeRichText(step.title);
            const descriptionData = normalizeRichText(step.description);

            return (
              <div
                key={step.number}
                className={`flex flex-col ${stepCardClassName} ${childClasses()}`}
                style={getChildStyle(300 + index * 150)}
              >
                <div
                  className={`bg-theme-primary mb-4 flex h-12 w-12 items-center justify-center rounded-full text-lg font-bold text-white ${circleClassName}`}
                >
                  {step.number}
                </div>

                {titleData?.content && (
                  <RichText
                    styles={
                      titleData.styles || {
                        p: 'text-left text-theme-primary text-base md:text-lg font-semibold mb-2',
                      }
                    }
                  >
                    {titleData.content}
                  </RichText>
                )}

                {descriptionData?.content && (
                  <RichText
                    styles={
                      descriptionData.styles || {
                        p: 'text-left text-text-muted text-sm leading-6 max-w-[260px]',
                      }
                    }
                  >
                    {descriptionData.content}
                  </RichText>
                )}
              </div>
            );
          })}
        </div>

        {bottomTextData?.content && (
          <div className={childClasses()} style={getChildStyle(950)}>
            <RichText
              styles={
                bottomTextData.styles || {
                  p: 'mt-8 rounded-[4px] bg-[#F3F3F3] px-8 py-6 text-center text-[18px] font-Muli-Bold leading-[28px] text-[#10143F]',
                }
              }
            >
              {bottomTextData.content}
            </RichText>
          </div>
        )}
      </div>
    </section>
  );
}
